import initOneAppMiddleware from './create-one-app-middleware';
import messageHandlers from './app-message-handlers';
import actionHandlers from './app-action-handlers';

export default function createBlogOneAppMiddleware(config) {
  return initOneAppMiddleware({ ...config, actionHandlers, messageHandlers });
}
